import type {CompRef, Pointer} from '@wix/document-services-types'
import type {CreateExtArgs, ExtensionAPI} from '@wix/document-manager-core'
import type {StructureExtensionAPI} from '../structure'
import type {InnerElementsExtensionAPI} from '../builderComponents/innerElements'
import type {PlatformExtensionAPI} from '../platform'
import type {DataModelExtensionAPI} from '../dataModel/dataModel'
import * as constants from '../../constants/constants'
import _ from 'lodash'
import type {DataExtensionAPI} from '../data'
import type {SchemaExtensionAPI} from '../schema/schema'

interface RecursiveDataMap {
    [key: string]: string | RecursiveDataMap
}

interface PartialNewData {
    data: RecursiveDataMap
}

export const predicateBuilderComp = (extensionAPI: ExtensionAPI, componentType: string): boolean => {
    const {platform} = extensionAPI as PlatformExtensionAPI
    return !!platform.getBuilderCompAppData(componentType)
}

export const injectData = (
    createExtArgs: CreateExtArgs,
    pointer: Pointer,
    path: string[] | undefined,
    partialNewData: PartialNewData
) => {
    const {dataModel} = createExtArgs.extensionAPI as DataModelExtensionAPI

    const {schemaAPI} = createExtArgs.extensionAPI as SchemaExtensionAPI

    const {components} = createExtArgs.extensionAPI as StructureExtensionAPI

    const {innerElements} = createExtArgs.extensionAPI as InnerElementsExtensionAPI

    const {data} = createExtArgs.extensionAPI as DataExtensionAPI

    const isInnerElement = path !== undefined

    const type = isInnerElement ? path.join('|') : components.getComponentType(pointer)

    const componentData =
        (isInnerElement
            ? innerElements.getInnerElementData(pointer as CompRef, path)
            : dataModel.components.getItem(pointer, constants.DATA_TYPES.data)) ??
        schemaAPI.createItemAccordingToSchema(`${type}.Data`, constants.DATA_TYPES.data)

    //TODO- when evelyin fix data update , remove the merge send only partial
    if (isInnerElement)
        innerElements.setInnerElementData(pointer as CompRef, path, _.merge({}, componentData, partialNewData))
    else data.update(pointer as CompRef, _.merge({}, componentData, partialNewData))
}
